import { useEffect } from "react";

const setMeta = (name, content) => {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | Babybib` : "Babybib | Costura criativa para bebés";
    if (description) setMeta("description", description);
  }, [title, description]);
};
